// set default home component into history state on app init
history.pushState({
    component: 'home'
}, 'home', '');